<template>
  <el-dialog title="订单退款" v-model="refundVisible" width="60%">
    <el-form
      ref="form"
      label-width="80px"
      class="mt-10"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="退款金额" prop="refundAmount">
        <el-input-number
          v-model="form.refundAmount"
          :step="0.01"
          :min="0"
          :max="getRefundAmount()"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="退款原因" prop="refundReason">
        <el-input v-model="form.refundReason" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="refundVisible = false">取 消</el-button>
      <el-button :loading="refundLoading" type="primary" @click="refundOrder">
        确 定
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
import { refundOrder } from '@/api/chess'
import { checkRefundAmount } from '@/utils/tool'
export default {
  name: 'ChessRefund',
  emits: ['fetch-data'],
  data() {
    return {
      refundVisible: false,
      refundLoading: false,
      row: {},
      form: {
        orderId: '',
        refundAmount: 0,
        refundReason: '',
      },
      rules: {
        refundReason: [
          { required: true, trigger: 'blur', message: '请输入退款原因' },
        ],
      },
    }
  },
  methods: {
    showRefund(row) {
      this.row = row
      this.form.orderId = row.orderId
      this.form.refundAmount = 0
      this.form.refundReason = ''
      this.refundVisible = true
    },
    async refundOrder() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.refundLoading = true
          try {
            const result = await refundOrder({
              orderId: this.form.orderId,
              refundAmount: this.form.refundAmount,
              refundReason: this.form.refundReason,
            })
            this.refundLoading = false
            if (!!result) {
              this.refundVisible = false
              this.dialogFormVisible = false
              this.$message.success('退款成功')
              this.$emit('fetch-data')
            }
          } catch (error) {
            this.refundVisible = false
            this.dialogFormVisible = false
            this.$emit('fetch-data')
          }
        } else {
          return false
        }
      })
    },
    // 获取能退的金额
    getRefundAmount() {
      return checkRefundAmount(this.row)
    },
  },
}
</script>

<style lang="scss" scoped>
.mt-10 {
  margin-top: 10px;
}
</style>
